import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroMockup } from '../data/productImage';

/** PENDING: paste the live checkout URL (sales platform not defined yet). */
export const CHECKOUT_URL = 'https://figure-skating-class-ready.impultienda.ar/checkout';

/**
 * PENDING (Lucas): confirm the "total value" anchor. The only documented
 * anchors are Bonus 3 ($6.79) and Bonus 5 ($8.99); the rest is a proposal.
 */
export const TOTAL_VALUE = 90;
export const PRICE = 27;
const included = ['6 volumes · 52 group lessons', '5 instant-use bonuses', '300 landscape pages, print or phone', '30, 45 and 60-minute lesson versions', '20 coach worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-glacier-soft text-ink" data-id="element-298" data-mp="3h6bq8gd3oo71">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-299" data-mp="3c81ua3jjxjkd">
        <div className="text-center" data-id="element-300" data-mp="3vyf4ql3c4nyo">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber-deep" data-id="element-301" data-mp="3w1jgq4n1knzw">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-rink text-3xl sm:text-5xl" data-id="element-302" data-mp="9siak3o6wr3s">
            Everything you need to coach the{' '}
            <span className="text-glacier-deep" data-id="element-303" data-mp="3d97fjl84jsrc">next 52 weeks</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-card border border-glacier-dark bg-white shadow-card" data-id="element-304" data-mp="3i7si3raumoiy">
          <div className="bg-rink px-5 py-5 text-center" data-id="element-305" data-mp="3n6lkooolkv4c">
            <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-306" data-mp="3n523mvv4ag1i">
              Figure Skating Class Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-amber-hover" data-id="element-307" data-mp="2uhenpu4skdl7">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-308" data-mp="2zfg4u9inq2u1">
            <img src={heroMockup.src} alt={heroMockup.alt} width={2340} height={1560} className="mx-auto aspect-[3/2] w-full rounded-2xl object-cover shadow-mockup" data-id="element-309" data-mp="2rgct3nhefzrk" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-310" data-mp="315wilbzmarve">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-311" data-mp="2w9o480t8v2pa">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-amber/20" data-id="element-312" data-mp="28iiqbr6v6khm">
                    <CheckIcon className="h-3 w-3 text-amber-deep" aria-hidden="true" data-id="element-313" data-mp="23la5fiuc02co" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-314" data-mp="3tuabjdbumy03">
              <p className="text-[13px] text-ink-soft" data-id="element-315" data-mp="3ows45rdhcqu7">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-316" data-mp="aneup3bsktz">
                  ${TOTAL_VALUE} USD
                </span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-rink" data-id="element-317" data-mp="5a9sgzn2g33b">
                <span className="mt-2.5 font-display text-3xl font-semibold" data-id="element-318" data-mp="3ng4txxegegv2">$</span>
                <span className="font-display font-extrabold text-6xl leading-[0.9] sm:text-7xl" data-id="element-319" data-mp="3rfwv3p1ipkqe">
                  {PRICE}
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-320" data-mp="j2yabxvnhgi2">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-321" data-mp="a9356puj3q2f">
                <span className="rounded-full border border-amber bg-amber px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-amber-ink" data-id="element-322" data-mp="ea56dc80ac71">
                  Save ${TOTAL_VALUE - PRICE}
                </span>
                <span className="rounded-full border border-ice-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-323" data-mp="16qzfqxxj8gt9">
                  One-time payment
                </span>
                <span className="rounded-full border border-ice-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-324" data-mp="3a85y3o6girlz">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-325" data-mp="3192cacfwny3s">
                Get Figure Skating Class Ready — only ${PRICE}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-326" data-mp="3sz6v46o0od2w">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-327" data-mp="3o75de582xu5h">
                <li className="flex items-center gap-1.5" data-id="element-328" data-mp="3k63ke64raeby">
                  <LockIcon className="h-4 w-4 text-amber-deep" aria-hidden="true" data-id="element-329" data-mp="kjn7bn647mv8" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-330" data-mp="1yfohnpxfb2bz">
                  <ZapIcon className="h-4 w-4 text-amber-deep" aria-hidden="true" data-id="element-331" data-mp="1yh80noagrrhg" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-332" data-mp="27hxtqk8cb3rh">
                  <ShieldCheckIcon className="h-4 w-4 text-amber-deep" aria-hidden="true" data-id="element-333" data-mp="2cfz7qqqwscw3" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-334" data-mp="2r42iedfwccr8">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}